import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import {
  CreateNewPaymentSettlementRequest,
  FinalizePaymentSettlementRequest,
  GetPaymentRequestInfoResponse,
  GetPaymentSettlementResponse,
  GetPaymentSettlmentInfoResponse,
  GetSettlementRequestsBySupplierRequest,
  GetSettlementRequestsBySupplierResponse,
  PaymentSettlementKeyRequest,
} from "../models/supplierPayment.model";
import { ApiBaseUrl, SupplierPaymentBaseUrl } from "../config/config";

export const GetSettlementRequestsBySupplier = async (
  data: GetSettlementRequestsBySupplierRequest
): Promise<GetSettlementRequestsBySupplierResponse[]> => {
  return await Axios.post<
    ApiResultModel<GetSettlementRequestsBySupplierResponse[]>
  >(
    ApiBaseUrl + SupplierPaymentBaseUrl + "/GetSettlementRequestsBySupplier",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const CreateNewPaymentSettlement = async (
  data: CreateNewPaymentSettlementRequest
): Promise<string> => {
  return await Axios.post<ApiResultModel<string>>(
    ApiBaseUrl + SupplierPaymentBaseUrl + "/CreateNewPaymentSettlement",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetPaymentSettlements = (): Promise<GetPaymentSettlementResponse[]> => {
  return Axios.post<ApiResultModel<GetPaymentSettlementResponse[]>>(
    ApiBaseUrl + SupplierPaymentBaseUrl + "/GetPaymentSettlements"
  ).then((result) => {
    return result.data.data;
  });
};
export const GetPaymentSettlementsHistory = (): Promise<GetPaymentSettlementResponse[]> => {
  return Axios.post<ApiResultModel<GetPaymentSettlementResponse[]>>(
    ApiBaseUrl + SupplierPaymentBaseUrl + "/GetPaymentSettlementsHistory"
  ).then((result) => {
    return result.data.data;
  });
};

export const CancelPaymentSettlement = async (
  data: PaymentSettlementKeyRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierPaymentBaseUrl + "/CancelPaymentSettlement",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const FinalizePaymentSettlement = async (
  data: FinalizePaymentSettlementRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierPaymentBaseUrl + "/FinalizePaymentSettlement",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetPaymentRequestInfo = async (
  data: PaymentSettlementKeyRequest
): Promise<GetPaymentRequestInfoResponse> => {
  return await Axios.post<ApiResultModel<GetPaymentRequestInfoResponse>>(
    ApiBaseUrl + SupplierPaymentBaseUrl + "/GetPaymentRequestInfo",
    data
  ).then((result) => {
    return result.data.data;
  });
};

// export const GetPaymentRequestExcelInfo = async (
//     data: GetPaymentRequestInfoRequest
// ): Promise<GetPaymentRequestInfoResponse[]> => {
//     return await Axios.post<ApiResultModel<GetPaymentRequestInfoResponse[]>>(
//         ApiBaseUrl + SupplierPaymentBaseUrl + "/GetPaymentRequestExcelInfo",
//         data
//     ).then((result) => {
//         return result.data.data;
//     });
// };
export const GetPaymentRequestExcelInfo = async (
  data: PaymentSettlementKeyRequest
) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + SupplierPaymentBaseUrl + "/GetPaymentRequestExcelFile",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"پرونده های تسهیلات پذیرنده"} .xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const GetPaymentSettlementInfo = async (
  data: PaymentSettlementKeyRequest
): Promise<GetPaymentSettlmentInfoResponse> => {
  return await Axios.post<ApiResultModel<GetPaymentSettlmentInfoResponse>>(
    ApiBaseUrl + SupplierPaymentBaseUrl + "/GetPaymentSettlementInfo",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetPaymentSettlementZipFile = async (
  data: PaymentSettlementKeyRequest
) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + SupplierPaymentBaseUrl + "/GetPaymentSettlementZipFile",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/zip",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `مستندات.zip`);
    document.body.appendChild(link);
    link.click();
  });
};
